import script from "./supporterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./supporterPage.vue?vue&type=script&setup=true&lang=js"

import "./supporterPage.vue?vue&type=style&index=0&id=19ab980b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ab980b"]])

export default __exports__